import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Check } from 'lucide-react';
import { SERVICES } from '../mock';
import { Button } from './ui/button';

export default function ServicesGrid() {
  return (
    <section id="services" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center max-w-2xl mx-auto mb-14 reveal">
          <span className="text-[#17A2C4] font-bold uppercase tracking-wider text-sm">Our Services</span>
          <h2 className="text-3xl sm:text-4xl font-extrabold text-[#4E4E50] mt-2 mb-4">Delivery at every speed</h2>
          <p className="text-gray-600 text-lg">From straight-there ASAP runs to after-hours emergencies, we have a service tier built for the way you ship.</p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            return (
              <div key={s.id} className="reveal card-hover bg-white rounded-xl border border-gray-100 shadow-sm overflow-hidden flex flex-col" data-delay={i * 90}>
                <div className="relative h-40">
                  <img src={s.image} alt={`${s.name} courier service`} className="w-full h-full object-cover" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/55 to-transparent" />
                  <div className="absolute top-3 left-3 bg-[#17A2C4] text-white rounded-lg p-2">
                    <Icon size={20} />
                  </div>
                  <span className="absolute bottom-3 left-3 text-white text-xs font-bold bg-black/40 px-2.5 py-1 rounded-full">{s.eta}</span>
                </div>
                <div className="p-5 flex flex-col flex-1">
                  <h3 className="text-lg font-extrabold text-[#4E4E50]">{s.name}</h3>
                  <p className="text-sm font-semibold text-[#17A2C4] mb-2">{s.tagline}</p>
                  <p className="text-sm text-gray-600 mb-4 flex-1">{s.desc}</p>
                  <ul className="space-y-1.5 mb-4">
                    {s.features.map((f) => (
                      <li key={f} className="flex items-center gap-2 text-sm text-gray-700">
                        <Check size={15} className="text-[#17A2C4] shrink-0" /> {f}
                      </li>
                    ))}
                  </ul>
                  <Link to="/services" className="text-[#17A2C4] font-bold text-sm flex items-center gap-1 hover:gap-2 transition-all">
                    Learn more <ArrowRight size={15} />
                  </Link>
                </div>
              </div>
            );
          })}
        </div>

        <div className="text-center mt-12 reveal">
          <Link to="/services">
            <Button className="bg-[#17A2C4] hover:bg-[#128aa8] text-white font-bold px-8 py-6 gap-2">
              View all services <ArrowRight size={18} />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
}
